import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProfileHeader = ({ employee, onEditProfile }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="h-32 gradient-brand" />
      <div className="px-6 pb-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 -mt-16">
          <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4">
            <div className="relative">
              <div className="w-24 h-24 rounded-full border-4 border-card overflow-hidden bg-muted">
                <Image
                  src={employee?.avatar}
                  alt={employee?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute bottom-0 right-0 w-6 h-6 rounded-full bg-success border-2 border-card" />
            </div>
            
            <div className="sm:mb-2">
              <h1 className="text-2xl font-bold text-foreground mb-1">
                {employee?.name}
              </h1>
              <p className="text-sm text-muted-foreground mb-2">
                {employee?.position} • {employee?.company}
              </p>
              <div className="flex items-center gap-4 text-sm text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="Mail" size={16} />
                  <span>{employee?.email}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="Phone" size={16} />
                  <span>{employee?.phone}</span>
                </div>
              </div>
            </div>
          </div>
          
          <Button
            variant="outline"
            iconName="Edit"
            iconPosition="left"
            onClick={onEditProfile}
          >
            Edit Profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;